import { useTranslation } from "react-i18next";

export const NoReviewsYet = () => {
  const { t } = useTranslation();

  return (
    <div className="no-reviews">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="113"
        height="112"
        viewBox="0 0 113 112"
        fill="none"
      >
        <path
          d="M82.1621 23.3335H82.2034"
          stroke="#A6A6A6"
          stroke-width="7"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M82.1621 37.3335C93.7602 37.3335 103.162 23.3335 103.162 23.3335C103.162 23.3335 93.7602 9.3335 82.1621 9.3335C70.564 9.3335 61.1621 23.3335 61.1621 23.3335C61.1621 23.3335 70.564 37.3335 82.1621 37.3335Z"
          stroke="#A6A6A6"
          stroke-width="7"
        />
        <path
          d="M56.4749 56H56.5169M37.8291 56H37.871M75.1415 56H75.1835"
          stroke="#A6A6A6"
          stroke-width="7"
          stroke-linecap="square"
          stroke-linejoin="round"
        />
        <path
          d="M101.486 41.8596C109.756 73.4316 84.2725 98.0384 56.5311 98.0384C49.8797 98.0384 43.5527 96.7173 37.8258 94.3364L19.257 102.663C19.2211 102.679 19.1826 102.646 19.1929 102.608L23.8678 85.3642C15.2618 77.0557 9.83789 66.1819 9.83789 53.686C9.83789 29.1908 30.7432 9.3335 56.5311 9.3335"
          stroke="#A6A6A6"
          stroke-width="7"
        />
      </svg>

      <p className="no-reviews__text">{t("NoReviewsYet")}</p>
    </div>
  );
};
